module.exports = __webpack_public_path__ + "static/media/splash.6817ea57.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/Seers/splash.jpg
// module id = 140
// module chunks = 0